import { rest } from 'msw';
import { API_REST_URL } from 'config/variables';

import { authorsMock, coursesTableMock } from '../coursesTable.mock';

const getCourseAuthors = rest.get(
  `${API_REST_URL}/lms-manage/getAllAuthors/:clientId`,
  (req, res, ctx) => {
    return res(
      // ctx.delay(1000),
      ctx.json({
        data: authorsMock,
      }),
    );
  },
);

const getCourseTable = rest.post(
  `${API_REST_URL}/lms-manage/courseAll/:clientId`,
  (req, res, ctx) => {
    return res(
      // ctx.delay(1000),
      ctx.json(coursesTableMock),
    );
  },
);

export const courseTableHandlers = [/* getCourseAuthors,  */ getCourseTable];
